import { useContext, useRef } from 'react';
import { Outlet, useLocation } from 'react-router';
import { Badge, Box, IconButton, Sheet, Typography } from '@mui/joy';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import { LayoutContext } from '../../context';
import SidebarQuality from '../../components/Sidebar/SidebarQuality';

export default function LKPageQuality() {
    const { setSidebarOpen, notifUnread, setNotifPanelOpen } = useContext(LayoutContext);
    const scrollContainerRef = useRef(null);
    const storageActive = useLocation().pathname.startsWith('/storage');
    return (
        <Box sx={{ display: 'flex', height: '100dvh', overflow: 'hidden' }}>
            <SidebarQuality />
            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
                <Sheet component="header" sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}>
                    <IconButton aria-label="Открыть меню" onClick={() => setSidebarOpen(true)} sx={{ display: { md: 'none' } }}>
                        <MenuRoundedIcon />
                    </IconButton>
                    <Typography level="title-lg" sx={{ flex: 1 }}>{storageActive ? 'Хранилище' : 'Контроль качества'}</Typography>
                    <IconButton aria-label="Уведомления" onClick={() => setNotifPanelOpen(true)}>
                        <Badge badgeContent={notifUnread || 0}><NotificationsRoundedIcon /></Badge>
                    </IconButton>
                </Sheet>
                <Box ref={scrollContainerRef} component="main" sx={{ flex: 1, minHeight: 0, overflow: 'auto', p: { xs: 1, md: 2 } }}>
                    <Outlet context={{ scrollContainerRef }} />
                </Box>
            </Box>
        </Box>
    );
}